if(!document.querySelector('body.neos-backend')) {
    document.addEventListener("DOMContentLoaded", function () {
        const popup = document.getElementById("popupContainer");
        const closeButtons = popup.querySelectorAll("button, a");
        const alreadyRegisteredButton = document.getElementById("alreadyRegisteredButton");
        const consentCookieName = "KD_GDPR_CC";

        // Prüft, ob der Cookiebanner bereits bestätigt wurde
        const hasConsent = () => document.cookie.includes(consentCookieName);

        // Funktion zum Starten des 30-Sekunden-Popups
        const startPopupTimer = () => {
            if (document.cookie.includes("popupSeen")) return; // bereits gesehen

            setTimeout(() => {
                if (!document.cookie.includes("popupSeen")) {
                    popup.classList.remove("hidden");
                    closeButtons.forEach(btn => btn.setAttribute('tabindex', '0'));
                    if (alreadyRegisteredButton) alreadyRegisteredButton.setAttribute('tabindex', '0');
                }
            }, 30000);
        };

        // Funktion zum Setzen des technischen Cookies auf X Tage
        const setPopupCookie = (days) => {
            const maxAge = days * 24 * 60 * 60; // Tage in Sekunden
            document.cookie = `popupSeen=dismissed; max-age=${maxAge}; path=/; SameSite=Lax`;
        };

        // Funktion zum Schließen des Popups
        function closePopup(days = 7) {
            setPopupCookie(days);
            popup.classList.add("hidden");
            closeButtons.forEach(btn => btn.setAttribute('tabindex', '-1'));
            if (alreadyRegisteredButton) alreadyRegisteredButton.setAttribute('tabindex', '-1');
        }

        // Klick auf Standard-Buttons → 7 Tage
        closeButtons.forEach(btn => btn.addEventListener("click", () => closePopup(7)));

        // Klick auf "Ich bin bereits angemeldet" → 30 Tage
        if (alreadyRegisteredButton) {
            alreadyRegisteredButton.addEventListener("click", () => closePopup(30));
        }

        // Warten, bis Cookiebanner bestätigt ist
        function waitForConsent() {
            if (hasConsent()) {
                startPopupTimer();
                return;
            }
            setTimeout(waitForConsent, 500); // prüft alle 500ms erneut
        }

        waitForConsent();
    });
}
